export default __webpack_public_path__ + "3d5c859b79b6b2d85171b407e1178f89.png";